import React from 'react';
import { PlusIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { faq } from '../../data/faq';
export function Faq() {
  return <section className="border-b border-white/10 bg-ink-950" data-id="element-108" data-mp="1byq33x9ftt2t">
      <div className="mx-auto w-full max-w-xl px-4 py-12 sm:py-16 lg:max-w-3xl" data-id="element-109" data-mp="x4lfjztotj18">
        <h2 className="text-center font-display text-[26px] uppercase leading-[1.1] text-white sm:text-3xl lg:text-[40px]" data-id="element-110" data-mp="121tqpggf4msz">
          ❓ Domande <span className="text-accent" data-id="element-111" data-mp="1psppwyn7eka9">frequenti</span>
        </h2>

        <div className="mt-8 space-y-2.5" data-id="element-112" data-mp="1urk7xydck4tb">
          {faq.map(item => <details key={item.question} className="group rounded-xl border border-white/10 bg-ink-800 px-4 py-3.5 sm:px-5" data-id="element-113" data-mp="1g2nzi07dops6">
              <summary className="flex cursor-pointer list-none items-start justify-between gap-3 text-[14.5px] font-semibold leading-snug text-white marker:hidden sm:text-base" data-id="element-114" data-mp="1kzegqqux5rf6">
                {item.question}
                <PlusIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent transition-transform duration-150 ease-out group-open:rotate-45" aria-hidden="true" data-id="element-115" data-mp="2djmu1p8rcday" />
              </summary>
              <p className="mt-3 text-[14px] leading-relaxed text-white/60 sm:text-[15px]" data-id="element-116" data-mp="2yga8wu0c0tgl">
                {item.answer}
              </p>
            </details>)}
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-117" data-mp="37gglmdo7hpep">
          <CtaButton label="Voglio iniziare oggi per 19 €" data-id="element-118" data-mp="37f5hgcqumfn2" />
        </div>
      </div>
    </section>;
}